// extracted by mini-css-extract-plugin
export default {"colorPicker":"ColorPicker_colorPicker__ypgun","tile":"ColorPicker_tile__v38Ce"};